/*
 * @Author: yanghailong
 * @Date: 2023-08-23 09:07:31
 * @Last Modified by: yanghailong
 * @Last Modified time: 2025-01-10 10:16:54
 */
import { createFromJSON } from "./help.js"
import { GraphElement } from "../graph-element.js"


class EBlockElement extends GraphElement {

  static EBlockWorkState = {
    0x00: '空状态',
    0x01: '停机',
    0x02: '待机',
    0x03: '充电',
    0x04: '放电',
    0x05: '降额',
    0x06: '告警',
    0x07: '故障',
  }

  /**
   * 获取能量块工作状态
   * @param {number} state 工作状态
   * @returns {string} 工作状态描述
   */
  static getEBlockWorkState(state) {
    return this.EBlockWorkState[state] || '未知'
  }


  static fromJSON = createFromJSON(this)
  constructor(topology, x, y) {
    super(topology, 'eBlock', x, y, {
      text: '能量块',
      port: true
    })

    this.onLoad(() => {
      this.prop_y = -12

      this.addProperty('状态')
      this.addProperty('功率', 'kW')
      this.addProperty('电流', 'A')
      this.addProperty('电压', 'V')
      this.addProperty('SOC', '%', { fill: 'rgb(44, 213, 99)'})

    })
  }

  updateData(data) {
    this.updateProperty('状态', EBlockElement.getEBlockWorkState(data.state_eblock))
    this.updateProperty('功率', data.p_dc)
    this.updateProperty('电流', data.i_dc)
    this.updateProperty('电压', data.u_dc)
    this.updateProperty('SOC', data.soc)
  }
}



export { EBlockElement }
